import { Typography, Box, Container } from "@mui/material";
import DisplayLogo from "./LogoDisplay";




export default function About() {
    return(
        <Container sx={{ mt: 10}}>
            <Box  sx={{display: "flex", justifyContent: "center",my:3}}>
                    <DisplayLogo width={{xs: 80,md: 100}} height={{xs: 80,md: 100}} />
            </Box>
            <Box sx={{
                display: "flex",
                flexWrap: "wrap",
                margin: "auto",
                p: 4,
                justifyItems: "center",
                width: "100%",
                border: "1px solid",
                borderColor: "divider",
                borderRadius: "10px",
        }}>
            <Typography
                variant="h6"
                sx={{ 
                    mb: 2,
                    fontSize: "1.2rem"
                 }}
                >
                About
            </Typography>

            <Typography  sx={{
                whiteSpace: "normal", 
        }}>

            We specialize in high-quality custom printed ribbons designed to add a personal and 
            professional touch to your events, gifts, branding, and packaging. Whether you're a small business looking to 
            elevate your product presentation or planning a special event like a wedding, baby shower, or corporate celebration, 
            our custom ribbons are tailored to meet your unique needs.


            </Typography>
        </Box>
    </Container>
        
        
    )
}